// Only the hologram subscribes; the canvas context bridge sees a stable value.
export function createHologramStore() {
  let selection = -1;
  let timeout: ReturnType<typeof setTimeout> | undefined;
  const listeners = new Set<() => void>();
  const routeHologram = { current: -1 };
  const setCurrentHologram = (value: number) => {
    if (selection === value) return;
    selection = value;
    listeners.forEach((notify) => notify());
  };
  const cancelPending = () => {
    clearTimeout(timeout);
    timeout = undefined;
  };
  return {
    routeHologram,
    setCurrentHologram,
    changeHologram: (value: number) => {
      cancelPending();
      timeout = setTimeout(() => setCurrentHologram(value), 350);
    },
    revertHologram: () => {
      cancelPending();
      timeout = setTimeout(
        () => setCurrentHologram(routeHologram.current),
        1000
      );
    },
    getSnapshot: () => selection,
    getServerSnapshot: () => -1,
    subscribe: (notify: () => void) => {
      listeners.add(notify);
      return () => {
        listeners.delete(notify);
      };
    },
    cancelPending,
  };
}
